import React, { useMemo } from "react";
import { WSElement } from "../WSElement/WSElement.component";
import { FilterField } from "./FilterField";
import { FilterHeader } from "./FilterHeader";
import styles from "./WSFilters.module.scss";
import { WSFilter } from "./types";

export type FilterProps = {
  expanded?: boolean;
  onExpandedChange?: () => void;
} & WSFilter;

export const Filter: React.FC<FilterProps> = (props) => {
  const optionsVisible = useMemo(() => {
    if (props.type === "divider") {
      return false;
    }

    return props.nonExpandable ? true : props.expanded;
  }, [props.expanded, props.nonExpandable, props.type]);

  return (
    <WSElement className={styles.filter}>
      <FilterHeader {...props} />

      {optionsVisible && (
        <WSElement className={styles.filterField}>
          <FilterField {...props} />
        </WSElement>
      )}
    </WSElement>
  );
};
